import { GET_CONTACTS } from '../constants/contact';
import { SHOW_LOADING, HIDE_LOADING } from '../constants/commons';


export const getContacts = (contacts) => {
    return {
        type: GET_CONTACTS,
        payload: contacts
    }
}



export const showLoading = () => {
    return {
        type: SHOW_LOADING
    }
}

export const hideLoading = () => {
    return {
        type: HIDE_LOADING
    }
}